/**
 * Plugin global BMT — Sprint REFACTOR-COMPOSABLES (09/06/2026).
 *
 * Substitui a modificacao in-place do Dashboard.vue (Sprint UI-CHANNEL-STATUS,
 * hooks mounted/beforeUnmount) por um listener de rotas, removendo a logica BMT
 * do arquivo upstream (que tem alta rotatividade entre versoes do Chatwoot).
 *
 * COMPORTAMENTO PRESERVADO IDENTICO: o Dashboard.vue (AppContainer) e o layout
 * de TODAS as rotas sob /app/accounts/:accountId — incluindo Settings, pois
 * settings.routes sao FILHAS do AppContainer (ver dashboard.routes.js). Logo o
 * Dashboard.vue monta UMA vez ao entrar na conta e so desmonta ao sair dela;
 * o polling do bmtInboxHealth roda continuamente enquanto o usuario esta dentro
 * da conta (conversas, settings, contatos, etc.) e para ao sair.
 *
 * Replicamos isso disparando start/stop conforme a rota atual pertence (ou nao)
 * a arvore do AppContainer. A pagina `account_suspended` e um irmao (nao filho)
 * do AppContainer — naquela rota o Dashboard.vue nao monta, entao excluimos.
 *
 * As actions startPolling/stopPolling do store ja sao idempotentes
 * (guard `if (state.isPolling) return` + clearInterval seguro), entao chamadas
 * repetidas via afterEach nao vazam timers.
 *
 * Registrar UMA VEZ no entry point que monta o dashboard SPA
 * (entrypoints/dashboard.js), passando { store, router }.
 */

const isInsideAccountApp = route => {
  if (!route || !Array.isArray(route.matched)) return false;
  return route.matched.some(
    record =>
      typeof record.path === 'string' &&
      record.path.startsWith('/app/accounts/') &&
      record.name !== 'account_suspended'
  );
};

export default {
  install(app, options = {}) {
    const { store, router } = options;
    if (!store || !router) {
      // eslint-disable-next-line no-console
      console.warn('[bmtInboxHealthPlugin] requer { store, router }');
      return;
    }

    const sync = route => {
      if (isInsideAccountApp(route)) {
        store.dispatch('bmtInboxHealth/startPolling');
      } else {
        store.dispatch('bmtInboxHealth/stopPolling');
      }
    };

    router.afterEach(to => sync(to));

    // Boot inicial: se a app ja carrega direto numa rota de conta
    // (ex: refresh em /app/accounts/1/dashboard), o afterEach da navegacao
    // inicial cobre, mas sincronizamos defensivamente com a rota corrente.
    if (router.currentRoute && router.currentRoute.value) {
      sync(router.currentRoute.value);
    }
  },
};
